/**
 * IMPORTANT: When adding new icons to this file, you MUST also update the corresponding
 * icons.proto file at pkg/go/domains/cp/proto/agent/v3/icons.proto to maintain
 * consistency between the TypeScript and Go implementations.
 */

export { default as AnalysisIcon } from "./AnalysisIcon";
export { default as AnalystIcon } from "./AnalystIcon";
export { default as AnthropicIcon } from "./AnthropicIcon";
export { default as ApprovalIcon } from "./ApprovalIcon";
export { default as ArrowsInIcon } from "./ArrowsInIcon";
export { default as AuditIcon } from "./AuditIcon";
export { default as AutomationIcon } from "./AutomationIcon";
export { default as BackupIcon } from "./BackupIcon";
export { default as BestPracticesIcon } from "./BestPracticesIcon";
export { default as BoardIcon } from "./BoardIcon";
export { default as BrainstormingIcon } from "./BrainstormingIcon";
export { default as BudgetingIcon } from "./BudgetingIcon";
export { default as BullhornIcon } from "./BullhornIcon";
export { default as CampaignIcon } from "./CampaignIcon";
export { default as ChartIcon } from "./ChartIcon";
export { default as ChatIcon } from "./ChatIcon";
export { default as CheckIcon } from "./CheckIcon";
export { default as ChevronDownIcon } from "./ChevronDownIcon";
export { default as CodingIcon } from "./CodingIcon";
export { default as CollaborationIcon } from "./CollaborationIcon";
export { default as CommunicationIcon } from "./CommunicationIcon";
export { default as ComparisonIcon } from "./ComparisonIcon";
export { default as ComplianceIcon } from "./ComplianceIcon";
export { default as ConsultingIcon } from "./ConsultingIcon";
export { default as ContentCreationIcon } from "./ContentCreationIcon";
export { default as ContractIcon } from "./ContractIcon";
export { default as CreationIcon } from "./CreationIcon";
export { default as CustomerServiceIcon } from "./CustomerServiceIcon";
export { default as CustomerSuccessIcon } from "./CustomerSuccessIcon";
export { default as DataVisualizationIcon } from "./DataVisualizationIcon";
export { default as DeepSeekIcon } from "./DeepSeekIcon";
export { default as DeploymentIcon } from "./DeploymentIcon";
export { default as DesignIcon } from "./DesignIcon";
export { default as DiagnosisIcon } from "./DiagnosisIcon";
export { default as EmailIcon } from "./EmailIcon";
export { default as EngineeringIcon } from "./EngineeringIcon";
export { default as ExampleIcon } from "./ExampleIcon";
export { default as FeatureExplanationIcon } from "./FeatureExplanationIcon";
export { default as FeedbackIcon } from "./FeedbackIcon";
export { default as FinanceIcon } from "./FinanceIcon";
export { default as ForecastingIcon } from "./ForecastingIcon";
export { default as GiftIcon } from "./GiftIcon";
export { default as GoogleIcon } from "./GoogleIcon";
export { default as HowToIcon } from "./HowToIcon";
export { default as HubOutlinedIcon } from "./HubOutlinedIcon";
export { default as HumanResourcesIcon } from "./HumanResourcesIcon";
export { default as HybridKnowledgeIcon } from "./HybridKnowledgeIcon";
export { default as InformationIcon } from "./InformationIcon";
export { default as IntegrationIcon } from "./IntegrationIcon";
export { default as InterviewIcon } from "./InterviewIcon";
export { default as InventoryIcon } from "./InventoryIcon";
export { default as InvestigationIcon } from "./InvestigationIcon";
export { default as InvestmentIcon } from "./InvestmentIcon";
export { default as ITIcon } from "./ITIcon";
export type { IconComponent } from "./iconMapping";
export {
  getIconComponent,
  ICON_MAPPING,
  iconEnumToString,
  parseIconEnumFromString,
  SANCTIONED_ICONS,
} from "./iconMapping";
export { default as LegalIcon } from "./LegalIcon";
export { LiaAtomSolid } from "./LiaAtomSolid";
export { default as LibraryIcon } from "./LibraryIcon";
export { default as LightBulbIcon } from "./LightBulbIcon";
export { default as MaintenanceIcon } from "./MaintenanceIcon";
export { default as MarketingIcon } from "./MarketingIcon";
export { default as MeetingIcon } from "./MeetingIcon";
export { default as MetaIcon } from "./MetaIcon";
export { default as MigrationIcon } from "./MigrationIcon";
export { default as MinimalNavIcon } from "./MinimalNavIcon";
export { default as MonitoringIcon } from "./MonitoringIcon";
export { default as NavigateIcon } from "./NavigateIcon";
export { default as NegotiationIcon } from "./NegotiationIcon";
export { default as NetworkingIcon } from "./NetworkingIcon";
export { default as NeutralFaceIcon } from "./NeutralFaceIcon";
export { default as NextIcon } from "./NextIcon";
export { default as OnboardingIcon } from "./OnboardingIcon";
export { default as OpenAIIcon } from "./OpenAIIcon";
export { default as OperationsIcon } from "./OperationsIcon";
export { default as OptimizationIcon } from "./OptimizationIcon";
export { default as PaperclipIcon } from "./PaperclipIcon";
export { default as PauseIcon } from "./PauseIcon";
export { default as PencilSquareIcon } from "./PencilSquareIcon";
export { default as PlanningIcon } from "./PlanningIcon";
export { default as PlayIcon } from "./PlayIcon";
export { default as PlusIcon } from "./PlusIcon";
export { default as PresentationIcon } from "./PresentationIcon";
export { default as PreviousIcon } from "./PreviousIcon";
export { default as ProcessIcon } from "./ProcessIcon";
export { default as ProductManagementIcon } from "./ProductManagementIcon";
export { default as ProductUsageIcon } from "./ProductUsageIcon";
export { default as ProjectManagementIcon } from "./ProjectManagementIcon";
export { default as PromptIcon } from "./PromptIcon";
export { default as PrototypingIcon } from "./PrototypingIcon";
export { default as QuestionMarkIcon } from "./QuestionMarkIcon";
export { default as RecoveryIcon, default as RefreshIcon } from "./RecoveryIcon";
export { default as RecruitmentIcon } from "./RecruitmentIcon";
export { default as RedoIcon } from "./RedoIcon";
export { default as ReportingIcon } from "./ReportingIcon";
export { default as ResearchIcon } from "./ResearchIcon";
export { default as ReviewIcon } from "./ReviewIcon";
export { default as RoadmapIcon } from "./RoadmapIcon";
export { default as SalesIcon } from "./SalesIcon";
export { default as SchedulingIcon } from "./SchedulingIcon";
export { default as SearchIcon } from "./SearchIcon";
export { default as SecurityIcon } from "./SecurityIcon";
export { default as SettingsIcon } from "./SettingsIcon";
export { default as ShareIcon } from "./ShareIcon";
export { default as ShortcutIcon } from "./ShortcutIcon";
export { default as SlashInBoxIcon } from "./SlashInBoxIcon";
export { default as SmileIcon } from "./SmileIcon";
export { default as SparklesIcon } from "./SparklesIcon";
export { default as StarIcon } from "./StarIcon";
export { default as StopIcon } from "./StopIcon";
export { default as StrategyIcon } from "./StrategyIcon";
export { default as SupportIcon } from "./SupportIcon";
export { default as SyncIcon } from "./SyncIcon";
export { default as SynthesisIcon } from "./SynthesisIcon";
export { default as TaskIcon } from "./TaskIcon";
export { default as TemplateIcon } from "./TemplateIcon";
export { default as TestingIcon } from "./TestingIcon";
export { default as TildeIcon } from "./TildeIcon";
export { default as TrainingIcon } from "./TrainingIcon";
export { default as TransformationIcon } from "./TransformationIcon";
export { default as TrashIcon } from "./TrashIcon";
export { default as TroubleshootingIcon } from "./TroubleshootingIcon";
export { default as TutorialIcon } from "./TutorialIcon";
export * from "./types";
export { default as UndoIcon } from "./UndoIcon";
export { default as UserExperienceIcon } from "./UserExperienceIcon";
export { default as UserIcon } from "./UserIcon";
export { default as VendorIcon } from "./VendorIcon";
export { default as WarningIcon } from "./WarningIcon";
export { default as WorkflowGuidanceIcon } from "./WorkflowGuidanceIcon";
export { default as WorkflowIcon } from "./WorkflowIcon";
export { default as WorkspacesIcon } from "./WorkspacesIcon";
export { default as WorldIcon } from "./WorldIcon";
export { default as WorldKnowledgeIcon } from "./WorldKnowledgeIcon";
export { default as WriteIcon } from "./WriteIcon";
export { default as XMarkIcon } from "./XMarkIcon";
